import {Component, OnInit,Input, ViewEncapsulation} from '@angular/core';
import { CookieService } from "ngx-cookie-service";
import { Router } from "@angular/router";
import { RestUrlsConfig, GenericConfig } from '@signature-it/ngx-generic/config';


@Component({
    selector: 'variety-options',
    templateUrl: './variety-options.html',
    styleUrls: ['./variety-options.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class VarietyOptionComponent implements OnInit {
    varietyName: string;
    varietyRedirect: string;
    @Input() sidebar: boolean = false;
    constructor( private cookie: CookieService,
                 private restUrlsConf: RestUrlsConfig,
                 protected router: Router,

    ) {}

    ngOnInit() {
        this.varietyRedirect = GenericConfig.varietyRedirect ? GenericConfig.varietyRedirect : null;
        this.varietyName =  this.cookie.get('varietyValue');
    }

    saveVariety(value) {
        this.cookie.set('varietyValue', value, null, '/', this.restUrlsConf.ssoDomain, false, 'Lax');
        this.varietyName = value;
        if (this.varietyRedirect) {
            window.location.href = this.varietyRedirect;
        }

    }

}
